module.exports = __webpack_public_path__ + "img/shape-12.0353bb5d.svg";